import { z } from '@tasama/utils';

export const companyTypeSchema = z
  .object({
    companyType: z.enum(['INTERNATIONAL', 'KSA_PRIVATE', 'pif-owned'], {
      error: 'Please select a company type',
    }),
    companyStatus: z
      .enum(['PIF_ESTABLISHED', 'PIF_UNDER_DEVELOPMENT'])
      .optional(),
  })
  .refine(
    (data) => {
      if (data.companyType === 'pif-owned') {
        return !!data.companyStatus;
      }
      return true;
    },
    {
      error: 'Please select a company status',
      path: ['companyStatus'],
    }
  );

export type CompanyTypeFormData = z.infer<typeof companyTypeSchema>;
